import HttpClient from "@/common/boot/HttpClient"

const listarTiposSolicitacao = async ({ commit }, payload) => {
  commit('CARREGANDO', true);
  try {
    const response = await HttpClient.get('/ctrl-tipo-solicitacao', { params: payload });
    commit('LISTAR_DADOS', response.data.data);
    return response;
  } finally {
    commit('CARREGANDO', false);
  }
}

const excluirTipoSolicitacao = async ({ commit }, payload) => {
    commit('CARREGANDO', true);

    try {
        await Promise.all(
            payload.map(item => excluir(item))
        );
    } finally {
        commit('CARREGANDO', false);
    }
}

const excluir = async(linha) => {
  const resp = await HttpClient.delete(`/ctrl-tipo-solicitacao/${linha.id}`).then(response => { return response; });
  return resp;
}

const salvarTipoSolicitacao = async ({ commit }, payload) => {
  commit('CARREGANDO', true);

  return await HttpClient.post('/ctrl-tipo-solicitacao', payload).then(response => {
    return response;
  })
  .finally( () => {
    commit('CARREGANDO', false);
  });
}

const atualizarTipoSolicitacao = async ({ commit }, payload) => {
  commit('CARREGANDO', true);

  return await HttpClient.put(`/ctrl-tipo-solicitacao/${payload.id}`, payload).then(response => {
    return response;
  })
  .finally( () => {
    commit('CARREGANDO', false);
  })
}


export {
  listarTiposSolicitacao,
  excluirTipoSolicitacao,
  salvarTipoSolicitacao,
  atualizarTipoSolicitacao,
}
